import React from 'react'

// Inline markdown: **bold**, *italic*, `code`.
function renderInline(text) {
  const parts = []
  const re = /(\*\*(.+?)\*\*|\*(.+?)\*|`(.+?)`)/g
  let last = 0, m
  while ((m = re.exec(text)) !== null) {
    if (m.index > last) parts.push(text.slice(last, m.index))
    if (m[2]) parts.push(<strong key={m.index}>{m[2]}</strong>)
    else if (m[3]) parts.push(<em key={m.index}>{m[3]}</em>)
    else if (m[4]) parts.push(
      <code key={m.index} style={{ background: '#f3f5f8', border: '1px solid #d0d2d5', borderRadius: 4, padding: '1px 5px', fontSize: '0.9em', fontFamily: 'monospace' }}>{m[4]}</code>
    )
    last = m.index + m[0].length
  }
  if (last < text.length) parts.push(text.slice(last))
  return parts
}

// Minimal block markdown: paragraphs + bullet lists. Mirrors the renderer used
// by the property assistant.
export default function MarkdownContent({ text }) {
  const lines = String(text || '').split('\n')
  return lines.map((line, i) => {
    if (line.trim() === '') return <div key={i} style={{ height: 6 }} />
    const bullet = line.match(/^\s*[-*]\s+(.+)/)
    if (bullet) {
      return (
        <div key={i} style={{ display: 'flex', gap: 6, margin: '2px 0' }}>
          <span style={{ color: '#5B68C3' }}>•</span>
          <span>{renderInline(bullet[1])}</span>
        </div>
      )
    }
    return <div key={i} style={{ margin: '1px 0' }}>{renderInline(line)}</div>
  })
}
